"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconBtnMargin = exports.defaultVariant = exports.defaultSize = exports.largeProp = exports.mediumProp = exports.smallProp = exports.textOnlyProp = exports.secondaryProp = exports.primaryProp = exports.classes = void 0;
var classes = {
  button: 'bds-btn',
  buttonPrimary: 'bds-btn-primary',
  buttonSecondary: 'bds-btn-secondary',
  buttonTextOnly: 'bds-btn-textOnly',
  buttonSmall: 'bds-btn-small',
  buttonMedium: 'bds-btn-medium',
  buttonLarge: 'bds-btn-large',
  disabled: 'bds-btn-disabled'
};
exports.classes = classes;
var primaryProp = 'primary';
exports.primaryProp = primaryProp;
var secondaryProp = 'secondary';
exports.secondaryProp = secondaryProp;
var textOnlyProp = 'textOnly';
exports.textOnlyProp = textOnlyProp;
var smallProp = 'small';
exports.smallProp = smallProp;
var mediumProp = 'medium';
exports.mediumProp = mediumProp;
var largeProp = 'large';
exports.largeProp = largeProp;
var defaultSize = 'medium';
exports.defaultSize = defaultSize;
var defaultVariant = 'primary';
exports.defaultVariant = defaultVariant;
var iconBtnMargin = '0.5rem';
exports.iconBtnMargin = iconBtnMargin;